var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-primary mb-2 align-items-center",on:{"click":_vm.createPage}},[_c('i',{staticClass:"icon icon-plus mr-1 typo-icon-10"}),_vm._v(" "+_vm._s(_vm.$t("agency.addShop"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }